import { Link } from 'react-router-dom';

export function DeniedPage() {
  return (
    <main className="page">
      <h1>Access denied</h1>
      <p>
        This Google account is not on the Mat Monitor list. An Admin has to add the email before
        sign-in works. No account was created.
      </p>
      <p>
        <Link to="/admin">Back to sign-in</Link>
      </p>
    </main>
  );
}
